export default {
  ACRONYM: 'PJN-CS',
  CARGANDO: 'Cargando',
  CLIENT: 'Client Seed',
  INGRESO: 'Ingreso al Sistema',
  INICIO: 'Inicio',
  'DESCRIPCION INICIO': 'Pagina de inicio',
  'OTRO VINCULO': 'Otro Vinculo',
  'DESCRIPCION OTRO VINCULO': 'Pagina de Otro Vinculo',
  'OPCION DOS': 'Opción 2',
  'DESCRIPCION OPCION DOS': 'Descripción de Opción 2',
  'CON SUBMENU': 'Submenú',
  'CON SUBMENU DOS': 'Submenú dos',
  'DESCRIPCION CON SUBMENU': 'Descripción de opción con submenú',
  'SUBMENU UNO': 'Submenú Uno',
  'DESCRIPCION SUBMENU UNO': 'Descripción opción con submenú uno',
  'SUBMENU DOS': 'Submenú dos',
  'DESCRIPCION SUBMENU DOS': 'Descripción opción con submenú dos',
  'DESCRIPCION CON SUBMENU DOS': 'Descripción de opción con submenú',
  'SUBMENU DOS UNO': 'Submenú Uno',
  'DESCRIPCION SUBMENU DOS UNO': 'Descripción opción con submenú uno',
  'SUBMENU DOS DOS': 'Submenú dos',
  'DESCRIPCION SUBMENU DOS DOS': 'Descripción opción con submenú dos',
  CONFIRMAR: 'Confirmar',
};
